import { Activityeditor } from '@linktivity/link-connect';
import config from '../config';

const pricingApi = new Activityeditor.PricingApi(config);

export default pricingApi;
